module.exports = __webpack_public_path__ + "public/img/noContent.9932a3b4.png";